var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4672 13.9969C11.3744 13.9969 8.86719 11.4897 8.86719 8.39687C8.86719 5.30408 11.3744 2.79688 14.4672 2.79688C17.56 2.79688 20.0672 5.30408 20.0672 8.39687C20.0672 11.4897 17.56 13.9969 14.4672 13.9969Z",
    fill: "#FBA12B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.24219 21.4644C1.24219 22.3395 1.48723 23.168 1.91897 23.8681C2.72411 25.2217 4.20604 26.1318 5.90967 26.1318C7.6133 26.1318 9.09522 25.2217 9.90036 23.8681C10.3321 23.168 10.5771 22.3395 10.5771 21.4644C10.5771 18.8856 8.48845 16.7969 5.90967 16.7969C3.33088 16.7969 1.24219 18.8856 1.24219 21.4644ZM3.90806 19.4626C4.10332 19.2673 4.4199 19.2673 4.61517 19.4626L5.90998 20.7573L7.20479 19.4626C7.40006 19.2673 7.71664 19.2673 7.9119 19.4626C8.10716 19.6579 8.10715 19.9744 7.91188 20.1697L6.6171 21.4644L7.91167 22.759C8.10694 22.9542 8.10695 23.2708 7.91169 23.4661C7.71643 23.6613 7.39985 23.6613 7.20458 23.4661L5.90998 22.1715L4.61538 23.4661C4.42011 23.6613 4.10353 23.6613 3.90827 23.4661C3.71301 23.2708 3.71302 22.9542 3.90829 22.759L5.20286 21.4644L3.90807 20.1697C3.71281 19.9744 3.7128 19.6579 3.90806 19.4626Z",
    fill: "#FBA12B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1323 25.1969C12.337 25.1969 11.8338 24.2888 12.0802 23.5326C12.3027 22.8495 12.423 22.1201 12.423 21.3627C12.423 20.3408 12.204 19.37 11.8104 18.4947C11.5276 17.8658 11.8008 17.0723 12.4811 16.9594C13.1228 16.8528 13.7871 16.7969 14.4674 16.7969C19.8687 16.7969 24.2674 20.3249 24.2674 24.6719C24.2674 24.9659 24.0302 25.1969 23.7284 25.1969H13.1323Z",
    fill: "#FBA12B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveMember);
export default __webpack_public_path__ + "static/media/remove-member.024043b605d8613684ed82fdb76732b6.svg";
export { ForwardRef as ReactComponent };